import { render } from "./EmailList.vue?vue&type=template&id=7dcac114&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=ts"
export * from "./EmailList.vue?vue&type=script&lang=ts"

import "./EmailList.vue?vue&type=style&index=0&id=7dcac114&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7dcac114"

export default script